@import '../../utils/global.module.less';

.exportButton {
    background: #4285f4 !important;
    border: none !important;
    border-radius: 8px !important;
    color: white !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    padding: 8px 16px !important;
    height: auto !important;
    width: auto !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;

    &:hover {
        background: #3367d6 !important;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
        transform: translateY(-1px) !important;
    }

    &:active {
        background: #2851a3 !important;
        transform: translateY(0) !important;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    }

    .plusIcon {
        font-size: 18px;
        font-weight: normal;
        color: inherit !important;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        pointer-events: none;
    }
}
